import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import { setAuth } from './Redux/Actions/authActions';
import Clients from './Containers/Clients/Clients';
import Employees from './Containers/Employees/Employees';
import Trucks from './Containers/Trucks/Trucks';
import Toolboxes from './Containers/Toolboxes/Toolboxes';
import Users from './Containers/Users/Users';
import Config from './Containers/Config/Config';
import Dispatch from './Containers/Dispatch/index';
import Login from './Containers/Login/Login';

const AdminRoute = ({ component: Component, auth, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (auth.isAuthenticated && auth.user.userType === 'admin' ? (
      <Component {...props} />
    ) : (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: props.location },
        }}
      />
    ))}
  />
);

const BasicRoute = ({ component: Component, auth, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (auth.isAuthenticated ? (
      <Component {...props} />
    ) : (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: props.location },
        }}
      />
    ))}
  />
);

class Routes extends PureComponent {
  render() {
    const { auth } = this.props;

    return (
      <Switch>
        <Route path="/login" name="Login" component={Login} />
        <AdminRoute
          path="/clients"
          name="Clients"
          component={Clients}
          auth={auth}
        />
        <AdminRoute
          path="/employees"
          name="Employés"
          component={Employees}
          auth={auth}
        />
        <AdminRoute
          path="/trucks"
          name="Véhicules"
          component={Trucks}
          auth={auth}
        />
        <AdminRoute
          path="/toolboxes"
          name="Coffres"
          component={Toolboxes}
          auth={auth}
        />
        <AdminRoute path="/users" name="Usagés" component={Users} auth={auth} />
        <AdminRoute
          path="/configurations"
          name="Configurations"
          component={Config}
          auth={auth}
        />
        <BasicRoute path="/" name="Cédule" component={Dispatch} auth={auth} />
      </Switch>
    );
  }
}

Routes.defaultProps = {
  auth: {},
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  onSetAuth: () => dispatch(setAuth()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Routes);
